import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_stacktrace/test-suites/$id/_layout/test-plan/_layout/')({});